import { render, staticRenderFns } from "./StempelCard.vue?vue&type=template&id=6c35cf96&"
import script from "./StempelCard.vue?vue&type=script&lang=js&"
export * from "./StempelCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports